/** @format */

import {makeStyles, createStyles} from '@mui/styles';
import {Theme, styled} from '@mui/material/styles';

import {Box} from '@mui/material';

import {VariantType} from '../model/types';
import {getColor} from '../helpers/getColor';

interface StyledRowProps {
  hover: boolean;
}

export const StyledRow = styled(Box, {
  shouldForwardProp: prop => prop !== 'hover',
})<StyledRowProps>(({theme, hover}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
  padding: theme.spacing(4.5, 6),
  borderRadius: '8px',
  background: hover
    ? theme.palette.semantic_dark?.surface.surface2
    : theme.palette.semantic_dark?.surface.surface1,
  transition: 'background 0.2s',
  boxShadow: '1px 1px 5px 0 rgba(0, 0, 0, 0.05)',
  '&:first-of-type': {
    marginTop: 0,
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(4.5, 4.5),
  },
}));

interface StyledRightColumnProps {
  colorScheme: VariantType;
}

export const StyledRightColumn = styled(Box, {
  shouldForwardProp: prop => prop !== 'colorScheme',
})<StyledRightColumnProps>(({theme, colorScheme}) => ({
  width: '100%',
  maxWidth: '160px',
  flexShrink: 0,
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1),
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(1.5, 4),
  borderRadius: '8px',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: getColor(colorScheme, theme?.palette.figma_gray_middle_dark?.main || ''),
  color: getColor(colorScheme, theme.palette.figma_gray_middle_dark?.main || ''),
  [theme?.breakpoints.down('sm')]: {
    maxWidth: '100%',
  },
}));

export const useSensorBarCategoriesStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      color: theme.palette.text.primary,
      fontSize: 20,
      fontWeight: 700,
      lineHeight: '26px',
      letterSpacing: '0.17px',
    },
    description: {
      color: theme.palette.figma_gray_middle_dark?.main,
      fontSize: '14px',
    },
    recommendationsText: {
      fontSize: 14,
    },
    headingBox: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
      },
    },
    headingIconAndText: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2.5),
    },
    content: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(4),
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
      },
    },
    contentLeftColumn: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      width: '100%',
    },
    iconBox: {
      width: '24px',
      height: '24px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  }),
);
